/**
 * Shadow geometry presets. Pure value (no React/RN imports).
 *
 * Geometry only — themed shadow COLORS are added to the color tree and merged
 * by useShadow(). `focusRing` renders as a centered, un-offset colored halo
 * (via the semantic.shadow.focusRing color) — a soft focus glow on iOS/web.
 * (Android draws elevation shadows only, so elevation stays 0 here.)
 */
export const SHADOW_SHAPES = {
  card: { shadowOffset: { width: 0, height: 2 }, shadowRadius: 8, elevation: 3 },
  button: { shadowOffset: { width: 0, height: 1 }, shadowRadius: 2, elevation: 1 },
  dropdown: { shadowOffset: { width: 0, height: 4 }, shadowRadius: 16, elevation: 8 },
  fab: { shadowOffset: { width: 0, height: 4 }, shadowRadius: 12, elevation: 6 },
  modal: { shadowOffset: { width: 0, height: 8 }, shadowRadius: 24, elevation: 12 },
  focusRing: { shadowOffset: { width: 0, height: 0 }, shadowRadius: 4, elevation: 0 },
} as const;
